// extracted by mini-css-extract-plugin
export var modalFooter = "_mj-0";